// extracted by mini-css-extract-plugin
export default {"modalTitle":"LoginDialog_modalTitle__3t9s0","ant-modal-title":"LoginDialog_ant-modal-title__8MdX+","formBox":"LoginDialog_formBox__szbSC","spanBox":"LoginDialog_spanBox__gTDmk"};